"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FunctionalTabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _coreBaseProps = require("@vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/FunctionalTabs.style"));

var _TabsContext = require("./contexts/TabsContext");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FunctionalTabs = /*#__PURE__*/function (_PureComponent) {
  _inherits(FunctionalTabs, _PureComponent);

  var _super = _createSuper(FunctionalTabs);

  function FunctionalTabs() {
    var _this;

    _classCallCheck(this, FunctionalTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.componentName = 'FunctionalTabs';
    _this.state = {
      // The selected tab is, used to show the relative panel
      selectedTabId: _this.props.externallySetTabId || '',
      // An array of all the tabIds, used to preserve the order to allow switching between them using the keyboard
      tabList: [],
      // A JS object with { tabId: index } pairs, used to get the index of each tabId
      tabHash: {},
      // A boolean value that indicates if the selected tab needs to be focused on (not necessary when setting it externally)
      needFocus: false
    };

    _this.setSelectedTabId = function (tabId) {
      var needFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        selectedTabId: tabId,
        needFocus: needFocus
      });

      if ((0, _isFunction["default"])(_this.props.onTabClick)) {
        _this.props.onTabClick(tabId);
      }
    };

    _this.registerTab = function (tabId) {
      _this.setState(function (prevState) {
        var tabList = _toConsumableArray(prevState.tabList);

        var tabHash = _objectSpread({}, prevState.tabHash); // Push returns the length of the array


        var pos = tabList.push(tabId) - 1;
        tabHash[tabId] = pos;
        return _objectSpread(_objectSpread({}, _this.state), {}, {
          tabList: tabList,
          tabHash: tabHash,
          selectedTabId: prevState.selectedTabId ? prevState.selectedTabId : tabId
        });
      });
    };

    _this.setNextTab = function (event) {
      // @bug-fix
      // if user pressed 'tab' then do nothing and allow tab to jump to next element
      // without this user will be 'stuck' on the web element when using tab to navigate
      if (event.keyCode === 9) return; // I previously removed preventDefault, but after allowing Home and End to be used on Tab it became necessary

      event.preventDefault();
      var keyIndex = _this.state.tabHash[_this.state.selectedTabId];
      var nextTab = (0, _utils.getNextTab)(event.keyCode, _this.state.tabList.length, keyIndex, _this.props.accessibilityInfiniteScroll);

      if (nextTab >= 0) {
        _this.setSelectedTabId(_this.state.tabList[nextTab], true);
      }
    };

    return _this;
  }

  _createClass(FunctionalTabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.handleExternalTabChanges(prevProps);
    }
    /**
     * It sets state.selectedTabId to props.externallySetTabId.
     * @param {FunctionalTabsProps} prevProps
     */

  }, {
    key: "handleExternalTabChanges",
    value: function handleExternalTabChanges(prevProps) {
      var id = this.props.externallySetTabId; // Only set ID if externallySetTabId is not falsy, it's not equal to selectedTabId and externallySetTabId has changed

      if (!!id && id !== prevProps.externallySetTabId && id !== this.state.selectedTabId) {
        this.setSelectedTabId(id);
      }
    }
    /**
     * It sets selectedTabId and calls the callback onTabClick if specified
     * @param {string} tabId
     * @param {boolean} needFocus - This is necessary since there are cases when you don't want the focus to be on the tab
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_TabsContext.TabsContext.Provider, {
        value: {
          selectedTabId: this.state.selectedTabId,
          setSelectedTabId: this.setSelectedTabId,
          registerTab: this.registerTab,
          setNextTab: this.setNextTab,
          needFocus: this.state.needFocus,
          tabsNumberTotal: this.state.tabList.length,
          tabHash: this.state.tabHash
        }
      }, /*#__PURE__*/_react["default"].createElement(Styled.Tabs, _extends({
        id: this.props.id,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": this.props.componentName || this.componentName
      }, this.props.dataAttributes), this.props.children));
    }
  }]);

  return FunctionalTabs;
}(_react.PureComponent);

exports.FunctionalTabs = FunctionalTabs;
FunctionalTabs.defaultProps = {
  // Used to disable home/end buttons and scrolling at the end/beginning of the tablist
  accessibilityInfiniteScroll: true
};
FunctionalTabs.displayName = "FunctionalTabs";
var _default = FunctionalTabs;
exports["default"] = _default;
//# sourceMappingURL=FunctionalTabs.js.map